import createReducer from '../createReducer';
import {
  GET_COUNTRIES_LIST,
  GET_COUNTRIES_LIST_SUCCESS,
  GET_CADENCE_COUNTRIES_LIST,
  GET_CADENCE_COUNTRIES_LIST_SUCCESS,
} from '../actions/country';

export const initialState = {
  loadingCountries: false,
  countries: null,
  loadingCadenceCountries: false,
  cadenceCountries: null,
};

export default createReducer(initialState, {
  [GET_COUNTRIES_LIST]: draft => {
    draft.loadingCountries = true;
  },

  [GET_COUNTRIES_LIST_SUCCESS]: (draft, action) => {
    draft.loadingCountries = false;
    draft.countries = action.countries;
  },

  [GET_CADENCE_COUNTRIES_LIST]: draft => {
    draft.loadingCadenceCountries = true;
  },

  [GET_CADENCE_COUNTRIES_LIST_SUCCESS]: (draft, action) => {
    draft.loadingCadenceCountries = false;
    draft.cadenceCountries = action.countries;
  },
});
